<template>
  <fh-container>
    <v-card-title
      >Configuración de producto cultivo<v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-col class="py-0">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Nuevo producto cultivo
            </v-btn>
          </v-col>
        </template>
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-autocomplete
                      v-model="editProducto.variedad.idVariedad"
                      :items="listaVariedad"
                      item-text="nombre"
                      item-value="idVariedad"
                      outlined
                      label="Variedad"
                      :rules="completeRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editProducto.nombre"
                      label="Nombre"
                      :rules="commonRules"
                      :counter="nombreLength"
                      outlined
                      autofocus
                      ref="Variedadref"
                    ></v-text-field>
                  </v-col>
                  <v-col> </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-row class="text-center">
              <v-col class="py-0">
                <v-btn color="black" text @click="close" class="">
                  Cancelar
                </v-btn>
              </v-col>
              <v-col class="py-0">
                <v-btn color="primary" text @click="save"> Guardar </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-row>
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="listaProductoCultivo"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-5" @click="editProductoCultivo(item)">
              fa-pen
            </v-icon>
            <v-icon small @click="deleteProductoCultivo(item)" color="error">
              fa-trash
            </v-icon>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 text-break"
              >¿Está seguro que quiere eliminar el producto cultivo
              seleccionado?</v-card-title
            >
            <v-card-text class="text-center text-h5 red--text">{{
              editProducto.nombreProducto
            }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="black" text @click="closeDelete">Cancelar</v-btn>
              <v-btn color="error" text @click="deleteProductoCultivoConfirm"
                >Eliminar</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-row>
  </fh-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import FhContainer from "@/components/FhContainer";
import FhCard from "@/components/FhCard";
import ValoresRepository from "@/services/ValoresRepository";
export default {
  name: "AdminAgroProductosCultivo",
  components: { FhCard, FhContainer },
  data() {
    return {
      // dialog flags
      dialog: false,
      dialogDelete: false,
      valid: false,
      saveDisabled: false,
      nombreLength: 30,
      commonRules: [
        (v) => !!v || "Campo obligatorio",
        (v) =>
          !v ||
          v.length <= this.nombreLength ||
          `No debe superar ${this.nombreLength} caracteres`,
      ],
      completeRules: [(v) => !!v || "Campo obligatorio"],
      editedIndex: -1,
      editProducto: {
        idProductoCultivo: 0,
        nombre: "",
        nombreProducto: "",
        variedad: {
          idVariedad: 0,
          nombre: "",
          cultivo: {
            idCultivo: 0,
          },
        },
      },
      defaultProducto: {
        idProductoCultivo: 0,
        nombre: "",
        nombreProducto: "",
        variedad: {
          idVariedad: 0,
          nombre: "",
          cultivo: {
            idCultivo: 0,
          },
        },
      },
      headers: [
        { text: "Variedad", value: "variedad.nombre" },
        { text: "Nombre", value: "nombre" },
        { text: "Acciones", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapState("variedades", ["listaVariedad"]),
    ...mapState("productos", ["listaProductoCultivo"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Nueva producto cultivo"
        : "Editar producto cultivo";
    },
  },
  methods: {
    ...mapActions("variedades", ["fetchListaVariedad"]),
    ...mapActions("productos", [
      "fetchListaProductoCultivo",
      "clearListaProductosCultivo",
    ]),
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editProducto = Object.assign({}, this.defaultProducto);
        this.editedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editProducto = Object.assign({}, this.defaultProducto);
        this.editedIndex = -1;
      });
    },
    editProductoCultivo(productoCultivo) {
      this.editedIndex = this.listaProductoCultivo.indexOf(productoCultivo);
      this.editProducto = Object.assign({}, productoCultivo);
      this.dialog = true;
    },
    deleteProductoCultivo(productoCultivo) {
      this.editedIndex = this.listaProductoCultivo.indexOf(productoCultivo);
      this.editProducto = Object.assign({}, productoCultivo);
      this.dialogDelete = true;
    },
    async deleteProductoCultivoConfirm() {
      await ValoresRepository.debajaProductoCultivo(
        this.editProducto.idProductoCultivo
      );
      this.clearListaProductosCultivo();
      await this.fetchListaProductoCultivo();
      this.closeDelete();
    },
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.editedIndex > -1) {
            await ValoresRepository.actualizarProductoCultivo(
              this.editProducto.variedad.idVariedad,
              this.editProducto.idProductoCultivo,
              this.editProducto.nombre
            );
          } else {
            await ValoresRepository.crearProductoCultivo(
              this.editProducto.variedad.idVariedad,
              this.editProducto.nombre
            );
          }
          this.editProducto = Object.assign({}, this.defaultProducto);
          this.editedIndex = -1;

          this.clearListaProductosCultivo();
          await this.fetchListaProductoCultivo();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.close();
    },
  },
  async created() {
    await this.fetchListaProductoCultivo();
    await this.fetchListaVariedad();
  },
};
</script>
<style lang=""></style>
